module.exports = __webpack_public_path__ + "img/30_10.7f1f6db4.png";